import en from './en.json'
import Vue from 'vue';
import i18n from '@/locale/i18n';
import VeeValidate from 'vee-validate';
import enMessages from '../error-message/en'
import hiMessages from '../error-message/hi'

export const defaultLocale = 'en'

export const languages = {
  en: en
}
VeeValidate.Validator.extend('regex_url', {
  getMessage: (field) => `The ${field} field must be a valid URL ex : (www.google.com).`,
  validate: value => {
    let urlRegex = new RegExp("^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$");
    return urlRegex.test(value);

  }
});
VeeValidate.Validator.extend('regex_zip_code', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    let regex_zip_code = new RegExp("^[1-9][0-9]{5}");
    return regex_zip_code.test(value);
  }
});
VeeValidate.Validator.extend('regex_intl_zip_code', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    let regex_zip_code = new RegExp("^[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]$");
    return regex_zip_code.test(value);
  }
});
VeeValidate.Validator.extend('regex_pannumber', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    let regex_zip_code = new RegExp("^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$");
    return regex_zip_code.test(value);
  }
});
VeeValidate.Validator.extend('regex_pan_tannumber', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    let regex_zip_code = new RegExp("^[a-zA-Z]{4,5}[0-9]{4,5}[a-zA-Z]{1}$");
    return regex_zip_code.test(value);
  }
});
VeeValidate.Validator.extend('regex_cost', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    let regex_zip_code = new RegExp("^[1-9][0-9]{0,8}(\.[0-9]{0,2})?$");
    // let regex_zip_code = new RegExp("^[0-9]+\.[0-9][0-9]$");
    return regex_zip_code.test(value);
  }
});
VeeValidate.Validator.extend('regex_cost_decimal', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    let regex_zip_code = new RegExp("^\d{0,9}(\.\d{0,2})?$");
    // let regex_zip_code = new RegExp("^[0-9]+\.[0-9][0-9]$");
    return regex_zip_code.test(value);
  }
});

VeeValidate.Validator.extend('regex_esi', {
  getMessage: (field) => `Invalid ${field} `,
  validate: value => {
    // let regex_esi = new RegExp("^[0-9][1-9][0-9]{17}");
    let regex_esi = new RegExp("^((?!(00000000000000000)).?[0-9]{17})*$");
    return regex_esi.test(value);
  }
});




VeeValidate.Validator.extend('regex_gst', {
  getMessage: (field) => `The ${field} field must be valid GST Number ex : (22AAAAA0000A1Z5).`,
  validate: value => {
    //let gstRegex = new RegExp("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9][a-zA-Z0-9]{1}[a-zA-Z0-9]$");
    let gstRegex = new RegExp("^[0-9a-zA-Z]{15}$");    
    return gstRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_msme', {
  getMessage: (field) => `The ${field} field must be valid MSME Number ex : (
    UDYAM-XX-00-0000000)).`,
  validate: value => {
    let gstRegex = new RegExp("^UDYAM-[A-Z]{2}-[0-9]{2}-[0-9]{7}$");
    return gstRegex.test(value);
  }
});

VeeValidate.Validator.extend('regex_pf', {
  getMessage: (field) => `The ${field} field must be valid PF Number ex : (APKDP12345670001234567).`,
  validate: value => {
    let pfRegex = new RegExp("^[A-Z]{5}[0-9]{7}[A-Z0-9]{3}[0-9]{7}$");
    return pfRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_cin', {
  getMessage: (field) => `The ${field} field must be valid CIN Number ex : (U12345AA1234AAA123456).`,
  validate: value => {
    let cinRegex = new RegExp("^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$");
    return cinRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_company_name', {
  getMessage: (field) => `The name field must not contain special characters.`,
  validate: value => {
    let llpRegex = new RegExp("^[A-Za-z0-9 &-.\(\)]*$");
    return llpRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_llp', {
  getMessage: (field) => `The LLPIN field must be valid LLPIN ex : (ABC1234).`,
  validate: value => {
    let llpRegex = new RegExp("^[A-Za-z]{3}[0-9]{4}$");
    return llpRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_sern', {
  getMessage: (field) => `The Shop & Establishment Reg No. field must be valid ex : (ABC1234).`,
  validate: value => {
    let sernRegex = new RegExp("^[A-Za-z]{3}[0-9]{4}$");
    return sernRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_frn', {
  getMessage: (field) => `The Firm Registration Number field must be valid ex : (ABC1234).`,
  validate: value => {
    let frnRegex = new RegExp("^[A-Za-z]{3}[0-9]{4}$");
    return frnRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_ratio', {
  getMessage: (field) => `Please enter in valid ratio format ex: (1:8.5) decimals allowed. 0:0 not allowed`,
  validate: value => {
    let ratioRegex = (value+"").match(/^\d*\.?\d+:\d*\.?\d+$/g);
    let ratiozero = (value+"").split(':')
    var isZeroRatio = false
    if (ratiozero.length > 1 && ratiozero[0].trim().search(/[1-9]/i) == -1
    && ratiozero[1].trim().search(/[1-9]/i) == -1) {
      isZeroRatio = true
    }
    return ratioRegex === null || isZeroRatio ? false : true;
  }
});
VeeValidate.Validator.extend('regex_account_number', {
  getMessage: (field) => `The ${field} field must not contains special characters.`,
  validate: value => {
    let accountnumberRegex = new RegExp("^(?=.*?[1-9])[0-9a-zA-Z\.\\-\\\\\/\]+$");
    // let accountnumberRegex = new RegExp("^((?!([0]{})).?[0-9]*)$");
    return accountnumberRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_Email', {
  getMessage: (field) => `The ${field} field must be a valid E-mail.`,
  validate: value => {
    // let emailRegex = new RegExp("^[a-z0-9][a-z0-9_\.-]{0,}[a-z0-9]@[a-z0-9][a-z0-9_\.-]{0,}[a-z0-9][\.][a-z0-9]{2,4}$");
    let emailRegex = new RegExp("^(?=[^@]*[A-Za-z])([a-zA-Z0-9])(([a-zA-Z0-9])*([\._-])?([a-zA-Z0-9]))*@(([a-zA-Z0-9\-])+(\.))+([a-zA-Z]{2,4})+$");
    return emailRegex.test(value.toLowerCase());
  }
});
VeeValidate.Validator.extend('regex_duns', {
  getMessage: (field) => `The ${field} field must have 9 digits`,
  validate: value => {
    let dunsRegex = new RegExp("^([0-9]{9})$");
    // let dunsRegex = new RegExp("^((?!(000000000)).?[0-9]{9})*$");
    return dunsRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_mobile_number', {
  getMessage: (field) => `The ${field} field must contain only 10 digits and Starting Number should not be 0.`,
  validate: value => {
    let mobile_number_Regex = new RegExp("^[1-9][0-9]{9}$");
    return mobile_number_Regex.test(value);
  }
});
VeeValidate.Validator.extend('regex_mobile_number_universal', {
  getMessage: (field) => `The ${field} field must contain only digits and Starting Number should not be 0.`,
  validate: value => {
    let mobile_number_Regex = new RegExp("^[1-9]{1}[0-9]{9,11}$");
    return mobile_number_Regex.test(value);
  }
});
VeeValidate.Validator.extend('regex_mobile_register', {
  getMessage: (field) => `The ${field} field Starting Number should not be 0.`,
  validate: value => {
    let mobile_number_Regex = new RegExp("^(|[1-9][0-9]*)$");
    return mobile_number_Regex.test(value);
  }
});
VeeValidate.Validator.extend('regex_userName', {
  getMessage: (field) => `${field} can have uppercase, lowercase and special characters (only \`-\` and \`_\`) and without any spaces and upto 30 characters`,
  validate: value => {
    let regex_userName_validation = new RegExp(`^[a-zA-Z0-9-_]{1,30}$`);
    return regex_userName_validation.test(value);
  }
});
VeeValidate.Validator.extend('regex_password', {
  getMessage: (field) => `The ${field} must contain minimum 8 characters and upto 32 characters, lowercase and uppercase characters, a number, and at least 1 special character(!,@,#,$)`,
  validate: value => {
    let regex_password_validation = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!#])[A-Za-z0-9@$!#]{8,32}$");
    return regex_password_validation.test(value);
  }
});
VeeValidate.Validator.extend('regex_percentage', {
  getMessage: (field) => `The ${field} field must be within 100%`,
  validate: value => {
    let regex_percentage_validation = new RegExp(`^100$|^[0-9]{1,2}$|^[0-9]{1,2}\,[0-9]{1,3}$`);
    return regex_percentage_validation.test(value);
  }
});
VeeValidate.Validator.extend('regex_ifsc', {
  getMessage: (field) => `The ${field} is invalid IFSC code`,
  validate: value => {
    let regex_ifsc_validation = new RegExp(`^[A-Z0-9]{7}$`);
    return regex_ifsc_validation.test(value);
  }
});
VeeValidate.Validator.extend('regex_swift', {
  getMessage: (field) => `The ${field} is invalid Swift code`,
  validate: value => {
    let regex_ifsc_validation = new RegExp(`^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$`);
    return regex_ifsc_validation.test(value);
  }
});
VeeValidate.Validator.extend('regex_finance_ifsc', {
  getMessage: (field) => `The ${field} field must be valid IFSC Code ex : (AAAA0123456).`,
  validate: value => {
    let regex_ifsc_validation = new RegExp(`^[A-Z]{4}[A-Z0-9]{7}$`);
    return regex_ifsc_validation.test(value);
  }
});
// Extended custom rules for number
VeeValidate.Validator.extend('regex_number', {
  getMessage: (field) => `The ${field} must only contain numeric characters and may start with -.`,
  validate: value => {
    let numberRegex = new RegExp("^[-]?[0-9]*\d{0,2}$");
    return numberRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_strict_number', {
  getMessage: (field) => `The ${field} must only contain numeric characters.`,
  validate: value => {
    let numberRegex = new RegExp("^[0-9]$");
    return numberRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_number_noneg', {
  getMessage: (field) => `The ${field} must only contain numeric characters.`,
  validate: value => {
    let numberRegex = new RegExp("^[0-9]*\d{0,2}$");
    return numberRegex.test(value);
  }
});
// VeeValidate.Validator.extend('regex_approxnumber', {
//   getMessage: (field) => `The ${field} must not start with 0`,
//   validate: value => {
//     let approxnumberRegex = new RegExp("(^[1-9][0-9]{0,}$)|(^[0][.](([0][1-9])$|([1-9][0-9]{0,1})$))|(^[1-9][0-9]{0,}[.](([0][1-9]$)|([1-9][0-9]{0,1}$)))");
//     return approxnumberRegex.test(value);
//   }
// });
VeeValidate.Validator.extend('regex_negnumber', {
  getMessage: (field) => `The ${field} must not contains Negative Value and only Number allowed.`,
  validate: value => {
    let numbernegRegex = new RegExp("^[1-9][0-9]*\d{0,2}$");
    return numbernegRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_creditrating', {
  // getMessage: (field) => `The ${field} must follow the format (AA or AA+ or AA- or AA1+ or AA1- or AAA+ or AAA- or AAA1+ or AAA1-).`,
  getMessage: (field) => `The ${field} must contains capital Alphabetic and no spaces (may include Numbers and '-' or '+' at last) or '0'.`,
  validate: value => {
    let creditRatingRegex = new RegExp("(^[A-Z]{1,}[1-9]{1,}?[-+]$)|(^[A-Z]{1,}?[1-9]{1,}$)|(^[A-Z]{1,}$)|(^[A-Z]{1,}?[-+]$)|(^[0]$)");
    return creditRatingRegex.test(value.toUpperCase());
  }
});
VeeValidate.Validator.extend('regex_alphacaps', {
  getMessage: (field) => `The ${field} field must only contain capital alphabetic characters and no spaces.`,
  validate: value => {
    let alphacapsRegex = new RegExp("^[A-Z]{1,}$");
    return alphacapsRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_numless33', {
  getMessage: (field) => `The ${field} field must Number and must less than 33.`,
  validate: value => {
    let alphacapsRegex = new RegExp("^[A-Z]{1,}$");
    return alphacapsRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_percentage_decimal', {
  getMessage: (field) => `The ${field} field must not greater than 100.`,
  validate: value => {
    let regex_percentage = new RegExp("(^(100)$|^(100[.][0]{1,})$)|(^[0-9]{1,2}?[.][0-9]{1,}$)|(^[0-9]{1,}$)");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_special', {
  getMessage: (field) => `The ${field} field must only contain alphabetic characters and special characters.`,
  validate: value => {
    let regex_percentage = new RegExp("^([a-zA-Z !@#\$%\^\&*\)\(+=._-]+$)");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_numeric_special', {
  getMessage: (field) => `The ${field} field must only contain alphabetic characters, numbers and special characters.`,
  validate: value => {
    let regex_percentage = new RegExp("^[A-Za-z0-9 !@\n#\$%\^\&*\)\(+=._-]*$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_numeric_space', {
  getMessage: (field) => `The ${field} field must only contain alphabetic characters, numbers and space.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z0-9 ]*$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_numeric', {
  getMessage: (field) => `The ${field} field must only contain alphabetic characters and numbers.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z0-9]*$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_number_decimal', {
  getMessage: (field) => `The ${field} must only contain numeric characters ,Decimal values and may start with -.`,
  validate: value => {
    let numberRegex = new RegExp("^[-]?[0-9]+(\.([0-9]{1,})?)?$");
    return numberRegex.test(value);
  }
});
// Extended custom rules for Year
VeeValidate.Validator.extend('regex_year', {
  getMessage: (field) => `The ${field} must be between 1900 to ${new Date().getFullYear()}.`,
  validate: value => {
    let numberRegex = new RegExp(`^(190[0-9]|19[0-9][0-9]|200[0-9]|201[0-9]|${new Date().getFullYear()})`);
    return numberRegex.test(value);
  }
});
VeeValidate.Validator.extend('regex_min_llpin', {
  getMessage: (field) => `The LLPIN field must be at least 5 characters.`,
  validate: value => {
    return value && value.trim().length > 4 ? true : false;
  }
});
VeeValidate.Validator.extend('regex_min_frn', {
  getMessage: (field) => `The Firm Registration Number field must be at least 5 characters.`,
  validate: value => {
    return value && value.trim().length > 4 ? true : false;
  }
});
VeeValidate.Validator.extend('regex_min_sern', {
  getMessage: (field) => `The Shop & Establishment Reg No. field must be at least 5 characters.`,
  validate: value => {
    return value && value.trim().length > 4 ? true : false;
  }
});
VeeValidate.Validator.extend('regex_alpha_llpin', {
  getMessage: (field) => `The LLPIN field must be only alphanumeric.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z0-9]*$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_vat', {
  getMessage: (field) => `The VAT field must be only alphanumeric.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z0-9]*$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_tan', {
  getMessage: (field) => `The TAN number field must be of valid pattern.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_aadhaar', {
  getMessage: (field) => `The aadhaar number field must be 12 digit number.`,
  validate: value => {
    let regex_percentage = new RegExp("^[0-9]{12}$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_frn', {
  getMessage: (field) => `The Firm Registration Number field must be only alphanumeric.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z0-9]*$");
    return regex_percentage.test(value);
  }
});
VeeValidate.Validator.extend('regex_alpha_sern', {
  getMessage: (field) => `The Shop & Establishment Reg No. field must be only alphanumeric.`,
  validate: value => {
    let regex_percentage = new RegExp("^[a-zA-Z0-9]*$");
    return regex_percentage.test(value);
  }
});
// Use for  lange change for validation error message
Vue.use(VeeValidate, {
  i18n,
  fieldsBagName: 'veeFields',
  locale: defaultLocale,
  dictionary: {
    en: {
      messages: enMessages
    },
    hi: {
      messages: hiMessages
    },
  }
});